import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { GoogleAuthProvider, getAuth, signInWithPopup } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { from, tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AimiLocalStorageItem, AuthPatchState } from './auth-action';
import { User } from '@aimi/models';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  #firebaseApp = initializeApp(environment.googleCloud.firebaseAuth);
  #googleProvider = new GoogleAuthProvider();
  #auth = getAuth(this.#firebaseApp);
  #http = inject(HttpClient);
  #store = inject(Store);

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  setupAuthStageChange() {
    this.#auth.onAuthStateChanged(async (user) => {
      const isLoggedIn = user ? true : false;
      this.#store.dispatch(
        new AuthPatchState({
          isLoggedIn,
        }),
      );

      if (isPlatformBrowser(this.platformId)) {
        window.localStorage.setItem(
          AimiLocalStorageItem.LOGIN_STATUS,
          `${isLoggedIn}`,
        );
      }
    });
  }

  async googleSignInWithPopup() {
    const signedInUser = await signInWithPopup(
      this.#auth,
      this.#googleProvider,
    );
    const credential = GoogleAuthProvider.credentialFromResult(signedInUser);
    if (!credential) {
      throw new Error('Credentials are missing');
    }
    const token = credential.accessToken;
    // The signed-in user info.
    const user = signedInUser.user;
  }

  loginWithGoogle() {
    return this.#http
      .post<{
        user: User;
        userExist: boolean;
        scope: string;
      }>(`${environment.apiUrl}/authentication/loginWithGoogle`, null)
      .pipe(
        tap((res) => {
          if (isPlatformBrowser(this.platformId)) {
            window?.localStorage.setItem('scope', res.scope);
          }
        }),
      );
  }

  logout() {
    return from(this.#auth.signOut()).pipe(
      tap(() => {
        if (isPlatformBrowser(this.platformId)) {
          window.localStorage.clear();
        }
      }),
    );
  }

  getIdToken() {
    if (!this.#auth.currentUser) {
      return null;
    }
    return from(this.#auth.currentUser.getIdToken());
  }
}
